<template>
  <div 
    v-if="selected"
    class="room-preview clickable"
    @click="callPanorama(selected.orderNumber)"
  >
    <img
      :src="selected.thumb"
      class="preview-thumb"
      crossOrigin="anonymous"
    >
    <!-- <div class="room-audio">
      <audio controls>
        <source :src="selected.audio" type="audio/mpeg">
        Your browser does not support the audio element.
      </audio>
    </div> -->
    <div class="preview-title">
      {{ selected.titel}}
    </div>
    <div class="play-button">
      <img
        src="/img/play.svg"
      >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'preview',
  props: {
    
  },
  data () {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
        videos: 'getVideosData',
        // marked: 'getMarkedVideo',
        selected: 'getSelectedRoom'
    }),
    markedVideoThumb () {
      const thumb = this.marked
        ? this.videos.find(v => v.orderNumber === this.marked).thumb
        : undefined
      return thumb
    }

  },
  methods: {
    ...mapActions({
        
    }),
    callPanorama(nr) {
      // this.$router.push(`/panorama/${nr}`)
      this.$router.push(`/raum/${nr}`)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/scss/custom.scss';
.room-preview {
    width: 46%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 800;
    .preview-thumb {
      display: block;
      width: 100%;
    }
    .preview-title {
      padding: .4rem .8rem; 
      background-color: $red-light;
      color: $sand-light;
      font-size: $font-text-md;
      font-family: 'Titillium Web';
      font-weight: 400;
    }
    .play-button {
      position: absolute;
      top: calc(50% - 3.6rem);
      left: 0;
      width: 100%;
      img {
        display: block;
        width: 6rem;
        margin: 0 auto;
      }
    }
}
    
</style>
